const url = process.env.NEXT_PUBLIC_MANIFOLD_ID_VERIFICATION_API!;

export function verifyIdentity(data: {
  email: string;
  buyerAddress: string;
  listingId: number;
}) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
}
